import styled from 'styled-components';
import { color, font, query, space } from '@design/templateFns';

import { FavoriteButton } from '@components/MiscComponents/FavoriteButton';
import { CardContentDetailListStyled } from '../style';

//Property Listing Card

export const StyledFavoriteButton = styled(FavoriteButton)<{
  $isFavorite: boolean;
}>`
  display: inline-block;
  @media screen and (${query.below('desktop')}) {
  }
`;

export const PropertyListingStatusWrapper = styled.div`
  ${font('subhead-xs')};
  background-color: ${color('bg')};
  border-radius: ${space('xs')};
  padding: ${space('xs')} ${space('sm')};
  top: ${space('md')};
  left: ${space('md')};
  width: fit-content;
  position: absolute;
  z-index: 1;
`;

export const PropertyCooperativeAgencyStatus = styled(PropertyListingStatusWrapper)`
  right: ${space('md')};
  left: unset;
`;

export const StyledCardContentDetailList = styled(CardContentDetailListStyled)`
  > li {
    display: inline;

    &::after {
      content: '•';
      display: inline;
      margin-right: ${space('sm')};
      margin-left: ${space('sm')};
      color: ${color('gray2')};

      @media screen and (${query.below('desktop')}) {
        margin-right: ${space('xs')};
        margin-left: ${space('xs')};
      }
    }
    &:last-child {
      &::after {
        content: none;
      }
    }
  }
`;

export const ContactDetailList = styled.ul`
  list-style: none;
  display: inline;

  li {
    display: inline-block;

    &::after {
      content: '•';
      margin-right: ${space('sm')};
      margin-left: ${space('sm')};
      color: ${color('gray2')};

      @media screen and (${query.below('desktop')}) {
        margin-right: ${space('xs')};
        margin-left: ${space('xs')};
      }
    }
    &:last-child {
      &::after {
        content: none;
      }
    }
  }
`;

export const PropertyListingHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LinksWrapper = styled.div`
  ${font('body-sm-light')};
  line-height: 1.3;
  color: ${color('gray4')};
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  justify-content: space-between;
  @media screen and (${query.below('desktop')}) {
    ${font('body-xxs-light')};
  }

  span {
    // add one character of margin to the right of the span
    margin-right: ${space('xs')};
  }

  a {
    text-decoration: none;
    color: ${color('gray4')};

    &:hover {
      color: ${color('gray5')};
      text-decoration: underline;
    }
  }
`;

//Property Listing Images / Swiper Carousel
export const SwiperContainer = styled.div`
  .swiper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
    overflow: hidden;
  }

  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }

  .swiper-android .swiper-slide,
  .swiper-wrapper {
    transform: translate3d(0px, 0, 0);
  }
  .swiper-pointer-events {
    touch-action: pan-y;
  }
  .swiper-pointer-events.swiper-vertical {
    touch-action: pan-x;
  }
  .swiper-slide {
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    transition-property: transform;
  }
  .swiper-slide-invisible-blank {
    visibility: hidden;
  }
  /* Auto Height */
  .swiper-autoheight,
  .swiper-autoheight .swiper-slide {
    height: auto;
  }
  .swiper-autoheight .swiper-wrapper {
    align-items: flex-start;
    transition-property: transform, height;
  }
  .swiper-backface-hidden .swiper-slide {
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }

  /* Pagination */
  .swiper-pagination {
    position: absolute;
    text-align: center;
    transition: 300ms opacity;
    transform: translate3d(0, 0, 0);
    z-index: 10;
  }
  .swiper-pagination.swiper-pagination-hidden {
    opacity: 0;
  }
  .swiper-pagination-disabled > .swiper-pagination,
  .swiper-pagination.swiper-pagination-disabled {
    display: none !important;
  }
  /* Common Styles */
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-bullets.swiper-pagination-horizontal {
    bottom: ${space('lg')};
    left: 0;
    width: 100%;

    @media screen and (${query.atLeast('desktop')}) {
      bottom: ${space('xl')};
    }
  }
  /* Bullets */
  .swiper-pagination-bullets-dynamic {
    overflow: hidden;
    font-size: 0;
  }
  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    width: ${space('xs')};
    height: ${space('xs')};
    position: relative;
  }
  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
    width: ${space('sm')};
    height: ${space('sm')};
  }
  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
    width: ${space('sm')};
    height: ${space('sm')};
  }
  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
    width: 5px;
    height: 5px;
  }
  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
    width: ${space('xs')};
    height: ${space('xs')};
  }
  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
    width: 5px;
    height: 5px;
  }
  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
    width: ${space('xs')};
    height: ${space('xs')};
  }
  .swiper-pagination-bullet {
    width: ${space('sm')};
    height: ${space('sm')};
    display: inline-block;
    vertical-align: middle;
    border-radius: 50%;
    background: ${color('bg')};
    opacity: 0.45;
  }
  button.swiper-pagination-bullet {
    border: none;
    margin: 0;
    padding: 0;
    box-shadow: none;
    -webkit-appearance: none;
    appearance: none;
  }
  .swiper-pagination-clickable .swiper-pagination-bullet {
    cursor: pointer;
  }
  .swiper-pagination-bullet:only-child {
    display: none !important;
  }
  .swiper-pagination-bullet-active {
    opacity: 1;
    background: ${color('bg')};
  }
  .swiper-vertical > .swiper-pagination-bullets,
  .swiper-pagination-vertical.swiper-pagination-bullets {
    right: 10px;
    top: 50%;
    transform: translate3d(0px, -50%, 0);
  }
  .swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,
  .swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0;
    display: block;
  }
  .swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
  .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    top: 50%;
    transform: translateY(-50%);
    width: ${space('sm')};
  }
  .swiper-vertical
    > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet,
  .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet {
    display: inline-block;
    transition:
      200ms transform,
      200ms top;
  }
  .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
  .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 ${space('xs')};
  }
  .swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
  .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
  }
  .swiper-horizontal
    > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet,
  .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet {
    transition:
      200ms transform,
      200ms left;
  }
  .swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    transition:
      200ms transform,
      200ms right;
  }

  /* a11y */
  .swiper .swiper-notification {
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    opacity: 0;
    z-index: -1000;
  }
  .swiper-free-mode > .swiper-wrapper {
    transition-timing-function: ease-out;
    margin: 0 auto;
  }
  .swiper-grid > .swiper-wrapper {
    flex-wrap: wrap;
  }
  .swiper-grid-column > .swiper-wrapper {
    flex-wrap: wrap;
    flex-direction: column;
  }
  .swiper-fade.swiper-free-mode .swiper-slide {
    transition-timing-function: ease-out;
  }
  .swiper-fade .swiper-slide {
    pointer-events: none;
    transition-property: opacity;
  }
  .swiper-fade .swiper-slide .swiper-slide {
    pointer-events: none;
  }
  .swiper-fade .swiper-slide-active,
  .swiper-fade .swiper-slide-active .swiper-slide-active {
    pointer-events: auto;
  }
`;

export const PaginationWrapper = styled.div``;

export const LinkText = styled.div`
  max-width: 80%;
  @media screen and (${query.below('tablet')}) {
    max-width: 200px;
  }
`;
export const StyledLogoWrapper = styled.div`
  width: 49px;
  height: 19px;
  display: flex;
  position: relative;
`;
